/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Media_Files_HelpInputs */



/**
* | output |
* | --- |
* | "Select one or more audio/video files to process" |
*
* @param {Select_Media_Files_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_media_files_help = /** @type {((inputs?: Select_Media_Files_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Media_Files_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un ou plusieurs fichiers audio/vidéo à traiter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine oder mehrere Audio-/Videodateien zur Verarbeitung aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona uno o più file audio/video da elaborare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите один или несколько аудио/видеофайлов для обработки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione uno o más archivos de audio/video para procesar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择一个或多个音频/视频文件进行处理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理するオーディオ/ビデオファイルを1つ以上選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोसेस करने के लिए एक या अधिक ऑडियो/वीडियो फ़ाइलें चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um ou mais arquivos de áudio/vídeo para processar.")
	return /** @type {LocalizedString} */ ("Select one or more audio/video files to process")
});